import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const groupApi = {
  create: ({ title, avatarUrl, memberIds } = {}) =>
    imRequest.post(`${IM_API}/conversations/group`, {
      title,
      avatarUrl,
      memberIds: memberIds || [],
    }),

  updateProfile: (conversationId, { title, avatarUrl } = {}) =>
    imRequest.put(`${IM_API}/conversations/${conversationId}/profile`, {
      title,
      avatarUrl,
    }),

  addMembers: (conversationId, memberIds) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/members`, {
      memberIds,
    }),

  removeOrLeave: (conversationId, targetMemberId) =>
    imRequest.delete(`${IM_API}/conversations/${conversationId}/members/${targetMemberId}`),
};
